<swb-modal #modal="modal">
  <div modal-header><em *ngIf="bookingoffer">{{ getTitle(bookingoffer) }}</em>, {{ day | date:'d. M. yyyy' }}
  </div>
  <div modal-body>
    <div class="modal__confirmation" *ngIf="showConfirmation">
      <ng-container *ngIf="toCancelId">
        <label for="cancelled_reason">Opravdu chcete zrušit tuto rezervaci?</label>
        <textarea [(ngModel)]="cancelled_reason" name="cancelled_reason" style="height: 100px"
          placeholder="Důvod zrušení"></textarea>
      </ng-container>
      <ng-container *ngIf="toReactivateId">
          <label>Opravdu chcete znovu aktivovat tuto rezervaci?</label>
      </ng-container>
    </div>
    <div *ngIf="!showConfirmation">
      <div class="loading loading--dark" *ngIf="!isInitialized"></div>
      <div *ngIf="isInitialized">
        <div *ngIf="hasBookings()">
          <h3>Rezervace v tomto časovém okně</h3>
          <div *ngFor="let item of bookingoffer.booking_items">
            <h4>{{ getTitle(item) }}</h4>
            <ul class="widget__list" *ngIf="item.item_bookings.length > 0">
              <li *ngFor="let booking of item.item_bookings" class="widget__list__item">
                <span class="widget__list__title" [ngStyle]="{ 'opacity': booking.cancelled ? .4 : 1 }">
                  <ng-container *ngIf="booking.cancelled">(Zrušeno) </ng-container>
                  <strong>{{ booking.date_from | date:'d. M. yyyy' }} -
                    {{ booking.date_to | date:'d. M. yyyy' }} - <span
                      *ngFor="let record of generateArray(booking.formrecord.content); let i = index">
                      <ng-container *ngIf="i > 1">{{ record.value }} </ng-container>
                    </span></strong>
                </span>
                <span class="widget__list__actions">
                  <a *ngIf="!booking.cancelled" (click)="prepareCancel(booking.id)"
                    class="widget__list__actions__link widget__list__actions__link--remove">
                    <i class="ico-remove"></i>
                  </a>
                  <a *ngIf="booking.cancelled" (click)="prepareReactivate(booking.id)"
                    class="widget__list__actions__link">
                    <i class="ico-success"></i>
                  </a>
                </span>
              </li>
            </ul>
            <swb-no-data *ngIf="item.item_bookings.length == 0"
              text="Na tento den nejsou pro tuto položku žádné rezervace."></swb-no-data>
          </div>
        </div>
        <swb-no-data *ngIf="!hasBookings()" text="Na tento den zatím nejsou žádné rezervace."></swb-no-data>
      </div>
    </div>
  </div>
  <div modal-footer>
    <ng-container *ngIf="showConfirmation">
      <button class="cta cta--red" (click)="resetConfirmation()">Ne</button>
      <button class="cta cta--green" (click)="toggleBooking()">Ano</button>
    </ng-container>
  </div>
</swb-modal>
